module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.c3f7e117.png";